document.addEventListener("DOMContentLoaded", function () {
  if (window.Cloudlift && window.Cloudlift.options) {
    const appOptions = window.Cloudlift.options;

    console.log("🧠 Cloudlift App Config:", appOptions.config);
    console.log("🛒 Shopify Cart:", appOptions.shopifyCart);
    console.log("🛍️ Shopify Store:", appOptions.shopifyStore);
    console.log("💰 Currency Info:", appOptions.currency);
    console.log("📦 Products:", appOptions.products);
    console.log("📄 Full App Data:", appOptions);

    // Optional: Do something specific with product data
    if (appOptions.products && appOptions.products.length === 0) {
      console.warn("⚠️ No products loaded in appOptions.");
    }
  } else {
    console.error("❌ Cloudlift app data not found on window.Cloudlift.options");
  }
});


window.selectedBodyDataOptions = {};

function renderBodyDataOptions() {
  const container = document.getElementById("messung-list-item");
  const configs = window?.Cloudlift?.options?.App?.config?.configs;
  // Initialize the default selected options array
  const defaultSelectedOptions = [];
  if (!container || !Array.isArray(configs)) {
    return setTimeout(renderBodyDataOptions, 300);
  }

  const sectionElement = document.querySelector('.template-product-new-product');
  const currentProductId = sectionElement?.dataset.productId;

  const matchingConfigs = configs.filter(cfg => {
    const targetMode = cfg?.targetMode;

    if (targetMode === 1) {
      const conditionProducts = cfg?.conditions?.[0]?.products;
      const ids = Array.isArray(conditionProducts)
        ? conditionProducts.map(p => p.id)
        : [];
      return ids.includes(currentProductId);
    } else {
      const liveId = cfg?.product?.id || cfg?.targeting?.product?.id;
      return currentProductId == liveId;
    }
  });

  const allItems = matchingConfigs.flatMap(cfg => cfg.options || []);

  const messungField = allItems.find(
    item => (item.name || '').toLowerCase() === 'manuelle messung'
  );

  if (!messungField) {
    console.log("KÖRPERDATEN AUSFÜLLEN not found");
    return;
  }

  container.innerHTML = "";

  const rootGroup = document.createElement("div");
  rootGroup.className = "product-level";

  const rootBtn = document.createElement("div");
  rootBtn.className = "product-level-box";
  const selectedValue = (messungField.values || []).find(
    val => (val.value || '').replace(/\s+/g, '').toLowerCase() === 'manuell'
  );
  if (selectedValue?.text) {
    window.selectedBodyDataOptions = window.selectedBodyDataOptions || {};
    window.selectedBodyDataOptions["manuelle messung"] = selectedValue.value;
  }
  rootBtn.innerHTML = `<div class="product-level-box-title custom-popup-header"><h2>${selectedValue?.text}</h2></div>`;


  const childContainer = document.createElement("div");
  childContainer.className = "child-items second-inner-body";
  childContainer.style.display = "block"; // Ensure child items are always visible

  rootGroup.appendChild(rootBtn);
  rootGroup.appendChild(childContainer);
  container.appendChild(rootGroup);

  // GESCHLECHT(Gender) Title
  const geschlechtOption = allItems.find(i =>
    (i.name || "").toLowerCase() === "geschlecht"
  );
  const geschlechtInfo = geschlechtOption?.params?.info?.trim();
  const geschlechtIcon = geschlechtInfo
    ? `<span class="info-icon" title="${geschlechtInfo}">i</span>`
    : "";

  const genderBox = document.createElement("div");
  genderBox.className = "child-item";
  genderBox.innerHTML = `<div class="child-item-title back-title">
  <button class="back-btn" id="child-back-btn">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z" fill="black" />
    </svg>
  </button> GESCHLECHT ${geschlechtIcon}</div>`;
  childContainer.appendChild(genderBox);


  // Helper to render individual option values
  function renderOptionValues(wrapper, opt, groupKey) {
    // Special handling for textarea
    if (opt.type === "textarea") {
      const infoText = opt.params?.info?.trim();
      const label = (opt.label || opt.name || "Option").replace(/\s/g, "");
      const labelHtml = infoText
        ? `${label} <span class="info-icon" title="${infoText}">i</span>`
        : label;

      const fieldEl = document.createElement("div");
      fieldEl.className = "child-item";
      fieldEl.innerHTML = `<div class="child-item-title">${labelHtml}</div>`;
      const textareaEl = document.createElement("textarea");
      textareaEl.className = "sub-product-textarea";
      // textareaEl.placeholder = opt.label || "Bitte weitere Infos eingeben...";

      textareaEl.addEventListener("input", () => {
        const inputValue = textareaEl.value;
        window.selectedBodyDataOptions = window.selectedBodyDataOptions || {};
        window.selectedBodyDataOptions[groupKey] = inputValue;

        const selectedGender = window.selectedProductOptions?.["Geschlecht"];
        if (selectedGender) {
          window.selectedBodyDataOptions["Geschlecht"] = selectedGender;
        }

        // ✅ Rebuild the array with gender at top
        const selectedBodyDataArray = [
          ...(selectedGender ? [{ name: "Geschlecht", value: selectedGender }] : []),
          ...Object.entries(window.selectedBodyDataOptions)
            .filter(([key]) => key !== "Geschlecht")
            .map(([name, value]) => ({ name, value })),
        ];

        window.selectedBodyDataArray = selectedBodyDataArray;

        console.log("Textarea Input:", window.selectedBodyDataOptions);
        console.log("Updated Body Data Array:", selectedBodyDataArray);
        window.lastUpdatedProductOptionsGroup = "Body";
      });

      fieldEl.appendChild(textareaEl);
      wrapper.appendChild(textareaEl);
      const helpText = opt.params?.help?.trim();
      if (helpText) {
        const helpEl = document.createElement("div");
        helpEl.className = "select-help-text";
        helpEl.textContent = helpText;
        wrapper.appendChild(helpEl);
      }
      return; // Important: Stop here, don't continue for textarea
    }

    // For select and other types that use "values"
    if (!Array.isArray(opt.values)) return;

    const maleDefaults = [];
    const femaleDefaults = [];

    if (opt.type === "select") {
      const selectEl = document.createElement("select");
      selectEl.className = "sub-product-select";

      // Add placeholder as first option
      const placeholderText = opt.params?.textValueSelect || "Bitte auswählen...";
      const placeholderOption = document.createElement("option");
      placeholderOption.textContent = placeholderText;
      placeholderOption.disabled = true;
      placeholderOption.selected = true;
      placeholderOption.value = "";
      selectEl.appendChild(placeholderOption);

      // Render actual options
      opt.values
        .filter(val => val.visible !== false)
        .forEach(val => {
          const optionEl = document.createElement("option");
          optionEl.value = val.value || val.label || val.text || "Option";
          optionEl.textContent = `${val.text || val.label || val.value} ${val.price ? `(+€${val.price})` : ""}`;
          selectEl.appendChild(optionEl);
        });

      // Change event handler
      selectEl.addEventListener("change", () => {
        const selectedOption = selectEl.value;
        window.selectedBodyDataOptions = window.selectedBodyDataOptions || {};
        window.selectedBodyDataOptions[groupKey] = selectedOption;

        const selectedBodyDataArray = Object.entries(window.selectedBodyDataOptions).map(([name, value]) => ({
          name,
          value,
        }));
        window.selectedBodyDataArray = selectedBodyDataArray;

        console.log("Selected Body Data Array:", selectedBodyDataArray);
        window.lastUpdatedProductOptionsGroup = "Body";
      });

      wrapper.appendChild(selectEl);

      // ✅ Add help/info/validation text if available
      const helpText = opt.params?.help || opt.params?.info || opt.params?.validationMsg;
      if (helpText) {
        const helpEl = document.createElement("div");
        helpEl.className = "select-help-text";
        helpEl.textContent = helpText;
        wrapper.appendChild(helpEl);
      }
    }
    else {
      opt.values
        .filter(val => val.visible !== false)
        .forEach(val => {
          const valLabel = val.text || val.label || val.value || "Value";
          const valImage = val.img || "https://via.placeholder.com/60";
          const valPrice = val.price || "";

          const valEl = document.createElement("div");
          valEl.className = "sub-product-box";
          valEl.innerHTML = `
            <div class="sub-product-box-img"><img src="${valImage}" /></div>
            <div class="sub-product-box-title">${valLabel} ${valPrice ? `(+${formatCurrency(valPrice)})` : ""}</div>
          `;

          if (val.value === opt.value) {
            valEl.classList.add("selected");

            window.selectedBodyDataOptions = window.selectedBodyDataOptions || {};
            window.selectedBodyDataOptions[groupKey] = val.value;

            // ✅ Push default value with option name
            defaultSelectedOptions.push({
              name: opt.name || groupKey,
              value: val.value
            });


            // Separate default selected options based on name text
            defaultSelectedOptions.forEach(option => {
              const normalizedName = (option.name || "").replace(/\s+/g, "").toLowerCase();

              if (normalizedName.includes("weiblich")) {
                femaleDefaults.push(option);
              } else {
                maleDefaults.push(option);
              }
            });

            console.log("defaultSelectedOptions defaults:", defaultSelectedOptions);
            console.log("Male defaults:", maleDefaults);
            console.log("Female defaults:", femaleDefaults);
          }

          valEl.addEventListener("click", () => {
            const allBoxes = wrapper.querySelectorAll(".sub-product-box");
            allBoxes.forEach(box => box.classList.remove("selected"));
            valEl.classList.add("selected");

            // Initialize if undefined
            window.selectedBodyDataOptions = window.selectedBodyDataOptions || {};
            const selectedGender = window.selectedProductOptions?.["Geschlecht"];

            // ✅ Clean up opposite gender fields dynamically
            Object.keys(window.selectedBodyDataOptions).forEach((key) => {
              const normalizedKey = key.toLowerCase().replace(/\s+/g, "");
              if (selectedGender === "MÄNNLICH") {
                if (
                  normalizedKey.includes("weiblich") ||
                  normalizedKey.includes("körperformweiblich") ||
                  normalizedKey.includes("schulternweiblich")
                ) {
                  delete window.selectedBodyDataOptions[key];
                }
              } else if (selectedGender === "WEIBLICH") {
                if (
                  normalizedKey === "körperform" ||
                  normalizedKey === "schultern" ||
                  normalizedKey.includes("männlich")
                ) {
                  delete window.selectedBodyDataOptions[key];
                }
              }
            });

            // ✅ Update the selected option
            window.selectedBodyDataOptions[groupKey] = val.value;

            // ✅ Ensure gender is stored
            if (selectedGender) {
              window.selectedBodyDataOptions["Geschlecht"] = selectedGender;
            }

            // ✅ Rebuild the array with gender at top
            const selectedBodyDataArray = [
              { name: "Geschlecht", value: selectedGender },
              ...Object.entries(window.selectedBodyDataOptions)
                .filter(([key]) => key !== "Geschlecht")
                .map(([name, value]) => ({ name, value })),
            ];

            window.selectedBodyDataArray = selectedBodyDataArray;

            console.log("Selected Optionss:", window.selectedBodyDataOptions);
            console.log("Selected Body Data Arrays:", selectedBodyDataArray);

            window.lastUpdatedProductOptionsGroup = "Body";
          });



          wrapper.appendChild(valEl);
        });
    }
    document.addEventListener("click", function (event) {
      const wrapper = document.getElementById("messung-wrapper");

      // Check if the click is outside the messung-wrapper
      if (wrapper && !wrapper.contains(event.target)) {
        // Remove all .selected classes inside messung-wrapper
        const selectedItems = wrapper.querySelectorAll(".active");
        selectedItems.forEach(el => el.classList.remove("active"));
      }
    });

  }


  // Render MÄNNLICH (Man) & WEIBLICH (Woman) Options as Radio Buttons
  const genderContainer = document.createElement("div");
  genderContainer.className = "gender-radio-container tab-buttons";

 const genderOption = allItems.find(opt => opt.name === "Geschlecht");

  if (genderOption && genderOption.values) {
    genderOption.values.forEach(val => {
      const genderValue = val.value.toUpperCase(); // "männlich" → "MÄNNLICH"
      const genderText = val.text.replace(/\s+/g, '') || val.text || genderValue; // visible label: "M Ä N N L I C H" changed to MÄNNLICH

      let tooltipText = "";
      if (genderValue === "MÄNNLICH") {
        tooltipText = window.shopSettings?.mannlichInfo || "Männlich Info";
      } else if (genderValue === "WEIBLICH") {
        tooltipText = window.shopSettings?.weiblichInfo || "Weiblich Info";
      }
      const genderLabel = document.createElement("label");
      genderLabel.className = "gender-radio-label";
      genderLabel.innerHTML = `${genderText}`;

      const genderInput = document.createElement("input");
      genderInput.type = "radio";
      genderInput.name = "gender";
      genderInput.value = genderValue;
      genderInput.id = `gender-${genderValue}`;

      genderInput.addEventListener("change", () => {
        const selectedGender = genderInput.value;

        window.selectedProductOptions = window.selectedProductOptions || {};
        window.selectedBodyDataOptions = window.selectedBodyDataOptions || {};
        window.genderWiseBodyData = window.genderWiseBodyData || {};

        const manualEntry = window.selectedBodyDataOptions["manuelle messung"];
        const previousGender = window.selectedProductOptions["Geschlecht"];

        if (previousGender && previousGender !== selectedGender) {
          const toSave = { ...window.selectedBodyDataOptions };
          delete toSave["manuelle messung"];
          window.genderWiseBodyData[previousGender] = toSave;
        }

        const restoredData = window.genderWiseBodyData[selectedGender]
          ? { ...window.genderWiseBodyData[selectedGender] }
          : {};

        restoredData["Geschlecht"] = selectedGender;

        if (Object.keys(restoredData).length === 1) {
          if (selectedGender === "MÄNNLICH") {
            restoredData["Körperform"] = "Unsicher";
            restoredData["Schultern"] = "Normal";
          } else if (selectedGender === "WEIBLICH") {
            restoredData["K Ö R P E R F O R M - W E I B L I C H "] = "Unsicher";
            restoredData["Schultern weiblich "] = "Normal";
          }
        }

        if (manualEntry) {
          restoredData["manuelle messung"] = manualEntry;
        }

        window.selectedBodyDataOptions = restoredData;
        window.selectedProductOptions["Geschlecht"] = selectedGender;

        const genderFields = childContainer.querySelectorAll('.gender-fields');
        genderFields.forEach(field => {
          const fieldGender = field.getAttribute("data-gender");
          field.style.display = fieldGender === selectedGender ? "block" : "none";
        });

        const allGenderLabels = genderContainer.querySelectorAll(".gender-radio-label");
        allGenderLabels.forEach(label => label.classList.remove("active"));
        genderLabel.classList.add("active");

        window.selectedBodyDataArray = Object.entries(window.selectedBodyDataOptions).map(([name, value]) => ({
          name,
          value,
        }));

        // console.log("Selected Gender:", selectedGender);
        // console.log("Restored Body Data:", window.selectedBodyDataOptions);
        // console.log("Updated Body Data Array:", window.selectedBodyDataArray);

        window.lastUpdatedProductOptionsGroup = "Body";
      });

      // Default selection if "MÄNNLICH"
      if (genderValue === "MÄNNLICH") {
        genderInput.checked = true;
        setTimeout(() => genderInput.dispatchEvent(new Event("change")), 0);
      }

      genderLabel.prepend(genderInput);
      genderContainer.appendChild(genderLabel);
    });
  }

  childContainer.appendChild(genderContainer);

  // Create gender-specific fields
  ["MÄNNLICH", "WEIBLICH"].forEach(gender => {
    const genderFieldsContainer = document.createElement("div");
    genderFieldsContainer.className = "gender-fields";
    genderFieldsContainer.setAttribute("data-gender", gender);
    genderFieldsContainer.style.display = "none"; // Hide by default

    // Main group like "MÄNNLICH (Man)"
    const mainGenderGroup = allItems.find(option => {
      const groupName = (option.name || '').replace(/\s+/g, '').toUpperCase();
      return option.type === "group" && groupName === gender;
    });

    if (mainGenderGroup && Array.isArray(mainGenderGroup.options)) {
      const mainSection = document.createElement("div");
      mainSection.className = "gender-main-section";

      // Add Toggle Button for Main Section
      const toggleMainBtn = document.createElement("button");
      toggleMainBtn.className = "toggle-section-btn";

      // Use innerHTML to include the text and SVG icon
      toggleMainBtn.innerHTML = `
        <span>1. HIER WERDEN ZWINGENDE ANGABEN ERFASST, UM EIN MASSGESCHNEIDERTES PRODUKT HERZUSTELLEN</span>
        <span class="dr-icon">
          <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1269_1177)">
              <path d="M33.3564 16.6433C33.3564 7.6027 26.0277 0.273925 16.9871 0.273925C7.94656 0.273925 0.617489 7.6027 0.617488 16.6433C0.617488 25.6838 7.94656 33.0129 16.9871 33.0129C26.0235 33.0027 33.3463 25.6799 33.3564 16.6433ZM2.25463 16.6433C2.25463 8.5067 8.85056 1.91077 16.9871 1.91077C25.1237 1.91077 31.7196 8.5067 31.7196 16.6433C31.7196 24.7798 25.1237 31.3757 16.9871 31.3757C8.85445 31.3664 2.26392 24.7759 2.25463 16.6433Z" fill="black"/>
              <path d="M23.3328 14.7271C23.6304 14.3866 23.5957 13.8695 23.2555 13.5719C22.915 13.2746 22.3979 13.3093 22.1003 13.6495L16.9874 19.4931L11.8743 13.6492C11.5767 13.3087 11.0596 13.2743 10.7194 13.5716C10.3789 13.8692 10.3442 14.3863 10.6418 14.7268L16.3712 21.2744C16.5264 21.4522 16.7512 21.5541 16.9874 21.5541C17.2236 21.5541 17.4481 21.4522 17.6037 21.2744L23.3328 14.7271Z" fill="black"/>
            </g>
            <defs>
              <clipPath id="clip0_1269_1177">
                <rect width="32.7389" height="32.7389" fill="white" transform="translate(33.3564 0.273926) rotate(90)"/>
              </clipPath>
            </defs>
          </svg>
        </span>
      `;

      toggleMainBtn.addEventListener("click", () => {
        toggleMainBtn.classList.toggle("active");
        mainSection.style.display = mainSection.style.display === "none" ? "block" : "none";
      });


      // Append the button first, followed by the section
      genderFieldsContainer.appendChild(toggleMainBtn);  // Button
      genderFieldsContainer.appendChild(mainSection);   // Section below the button

      // mainSection.innerHTML = `<div class="gender-main-section-title">1. HIER WERDEN ZWINGENDE ANGABEN ERFASST, UM EIN MASSGESCHNEIDERTES PRODUKT HERZUSTELLEN</div>`;




      mainGenderGroup.options.forEach(opt => {
        const label = opt.label || opt.name || opt.text || "Option";
        const fieldEl = document.createElement("div");
        fieldEl.className = "child-item";
        const infoText = opt.params?.info?.trim();
        const labelHtml = infoText
          ? `${label} <span class="info-icon" title="${infoText}">i</span>`
          : label;

        fieldEl.innerHTML = `<div class="child-item-title">${labelHtml}</div>`;


        const valuesWrapper = document.createElement("div");
        valuesWrapper.className = "level-2-values";

        // ✅ Use gender-specific defaults
        const currentDefaults = label.toUpperCase().includes("MÄNNLICH") ? maleDefaults :
          label.toUpperCase().includes("WEIBLICH") ? femaleDefaults : [];

        // ✅ Pass correct defaults here
        renderOptionValues(valuesWrapper, opt, opt.name || label, currentDefaults);

        if (currentDefaults.length > 0) {
          const defaultSelectedEl = document.createElement("div");
          defaultSelectedEl.className = "default-selected-info";
          defaultSelectedEl.textContent = `Defaults: ${currentDefaults.map(d => d.value || d.label || d.name).join(", ")}`;
          fieldEl.appendChild(defaultSelectedEl);
          console.log("Defaults for", label, ":", currentDefaults);
        }

        fieldEl.appendChild(valuesWrapper);
        mainSection.appendChild(fieldEl);
      });


    }

    // Zusatzinfos group like "ZUSATZINFOS - MÄNNLICH"
    const addinfoGroup = allItems.find(option => {
      const groupName = (option.name || '').replace(/\s+/g, '').toUpperCase();
      const hasMatchingCondition = Array.isArray(option.conditions) &&
        option.conditions.some(cond =>
          (cond.field || '').toLowerCase().includes('geschlecht') &&
          (cond.value || '').toUpperCase() === gender
        );
      return option.type === "group" && hasMatchingCondition && groupName.includes("ZUSATZINFOS");
    });

    if (addinfoGroup && Array.isArray(addinfoGroup.options)) {
      const addinfoSection = document.createElement("div");
      addinfoSection.className = "gender-zusatz-section";
      addinfoSection.style.display = "none";

      // Add Toggle Button for Zusatz Section
      const toggleinfoBtn = document.createElement("button");
      toggleinfoBtn.className = "toggle-section-btn";

      // Set innerHTML to include text, dynamic gender, and SVG icon
      toggleinfoBtn.innerHTML = `
        <span>2. MÖGLICHE ZUSATZINFOS KÖRPERDATEN ${gender}</span>
        <span class="dr-icon">
          <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1269_1177)">
              <path d="M33.3564 16.6433C33.3564 7.6027 26.0277 0.273925 16.9871 0.273925C7.94656 0.273925 0.617489 7.6027 0.617488 16.6433C0.617488 25.6838 7.94656 33.0129 16.9871 33.0129C26.0235 33.0027 33.3463 25.6799 33.3564 16.6433ZM2.25463 16.6433C2.25463 8.5067 8.85056 1.91077 16.9871 1.91077C25.1237 1.91077 31.7196 8.5067 31.7196 16.6433C31.7196 24.7798 25.1237 31.3757 16.9871 31.3757C8.85445 31.3664 2.26392 24.7759 2.25463 16.6433Z" fill="black"/>
              <path d="M23.3328 14.7271C23.6304 14.3866 23.5957 13.8695 23.2555 13.5719C22.915 13.2746 22.3979 13.3093 22.1003 13.6495L16.9874 19.4931L11.8743 13.6492C11.5767 13.3087 11.0596 13.2743 10.7194 13.5716C10.3789 13.8692 10.3442 14.3863 10.6418 14.7268L16.3712 21.2744C16.5264 21.4522 16.7512 21.5541 16.9874 21.5541C17.2236 21.5541 17.4481 21.4522 17.6037 21.2744L23.3328 14.7271Z" fill="black"/>
            </g>
            <defs>
              <clipPath id="clip0_1269_1177">
                <rect width="32.7389" height="32.7389" fill="white" transform="translate(33.3564 0.273926) rotate(90)"/>
              </clipPath>
            </defs>
          </svg>
        </span>
      `;

      toggleinfoBtn.addEventListener("click", () => {
        toggleinfoBtn.classList.toggle("active");
        addinfoSection.style.display = addinfoSection.style.display === "none" ? "block" : "none";
      });

      // Append the button first, followed by the section
      genderFieldsContainer.appendChild(toggleinfoBtn);  // Button
      genderFieldsContainer.appendChild(addinfoSection);   // Section below the button

      // addinfoSection.innerHTML = `<div class="gender-main-section-title">2. MÖGLICHE ZUSATZINFOS KÖRPERDATEN ${gender}</div>`;

      addinfoGroup.options.forEach(opt => {
        const label = opt.label || opt.name || "Option";
        const infoText = opt.params?.info?.trim();
        const labelHtml = infoText
          ? `${label} <span class="info-icon" title="${infoText}">i</span>`
          : label;

        const fieldEl = document.createElement("div");
        fieldEl.className = "child-item";
        fieldEl.innerHTML = `<div class="child-item-title">${labelHtml}</div>`;

        const valuesWrapper = document.createElement("div");
        valuesWrapper.className = "level-2-values";

        renderOptionValues(valuesWrapper, opt, opt.name || label);

        fieldEl.appendChild(valuesWrapper);
        addinfoSection.appendChild(fieldEl);
      });
    }

    childContainer.appendChild(genderFieldsContainer);
  });

  rootGroup.appendChild(rootBtn);
  rootGroup.appendChild(childContainer);
  container.appendChild(rootGroup);
}

// color and design rendering

let currentBaseImage = null;
let currentDesignImage = null;
let layer3RefHeight = null; // <-- add this
window.selectedFarbeDesignValues = [];

function renderFarbeOption() {
  const container = document.getElementById("product-list-item1");
  const farbeContainer = document.getElementById("farbe-detail-container");
  const designContainer = document.getElementById("design-detail-container");
  const shirtPreview = document.getElementById("shirt-preview"); // <-- ID of shirt image in preview


  if (!container) return;


  const configs = window?.Cloudlift?.options?.App?.config?.configs;
  if (!Array.isArray(configs)) {
    return setTimeout(renderFarbeOption, 300);
  }
  console.log("config", configs)
  const productHandle = window?.meta?.product?.handle ||
    window.location.pathname.replace("/products/", "").replace("/", "").toLowerCase();

  console.log("productHandle", productHandle)

  const sectionElement = document.querySelector('.template-product-new-product');
  const currentProductId = sectionElement?.dataset.productId;
  console.log("currentProductId", currentProductId)
  
 const currentConfig = configs.find(cfg => {
    const handle = (cfg?.product?.handle || cfg?.targeting?.product?.handle || "").toLowerCase();
    return handle === productHandle;
  });
  console.log("currentConfig", currentConfig)

  
  const matchingConfigs = configs.filter(cfg => {
    const targetMode = cfg?.targetMode;
    if (targetMode === 1) {
      const conditionProducts = cfg?.conditions?.[0]?.products;
      const ids = Array.isArray(conditionProducts) ? conditionProducts.map(p => p.id) : [];
      return ids.includes(currentProductId);
    } else {
      const liveId = cfg?.product?.id || cfg?.targeting?.product?.id;
      return currentProductId == liveId;
    }
  });
console.log("matchingConfigs", matchingConfigs)
  if (matchingConfigs.length === 0) return;

const currentMatchingConfig = matchingConfigs[0]; // Get the first config
const allOptions = currentMatchingConfig?.options || [];
  
if (!currentMatchingConfig?.previewConfig?.layers) {
  console.log("No valid layers in previewConfig of matching config");
  return;
}

const layers = currentMatchingConfig.previewConfig.layers;
console.log("layers", layers);

//   const layers = matchingConfigs?.previewConfig?.layers;
// console.log("layers", layers)
  
  let refHeight = null;

  if (Array.isArray(layers)) {
    const layer3 = layers.find(layer => layer.name === 'layer_3');
    if (layer3?.params?.refHeight != null) {
      refHeight = layer3.params.refHeight;
      console.log('layer_3 refHeight:', refHeight);
    } else {
      console.log('refHeight not found in layer_3.params');
    }
  } else {
    console.log('No valid layers array in previewConfig');
  }


  // const allOptions = currentConfig?.options || [];


  // Reusable render function
function renderOptionGroup(optionName) {
    const optionGroup = allOptions.find(opt => opt.name === optionName);
    console.log("optionGroup", optionGroup)
    if (!optionGroup) return null;

    const wrapper = document.createElement("div");
    wrapper.className = "farbe-options";
    wrapper.innerHTML = `<h3>${optionGroup.label || optionName}</h3>`;

    const values = optionGroup?.values || [];
    if (values.length) {
      values.forEach(val => {
        const valDiv = document.createElement("div");
        valDiv.className = "farbe-item";

        if (val.img) {
          const img = document.createElement("img");
          img.src = val.img;
          img.alt = val.text || val.value || optionName;
          valDiv.appendChild(img);
        }

        const label = document.createElement("div");
        label.textContent = val.text || val.value || "Unnamed";
        valDiv.appendChild(label);

        // Click handler for both Farbe and Design
        valDiv.addEventListener("click", () => {
          // Remove selected class from all items in this group
          wrapper.querySelectorAll('.farbe-item').forEach(item => {
            item.classList.remove('selected');
          });

          // Add selected class to clicked item
          valDiv.classList.add('selected');

          // Existing functionality for Farbe
          if (optionName === "Farbe") {
            window.selectedFarbeDesignValues = window.selectedFarbeDesignValues.filter(
              item => !item.name.includes("Farbe")
            );

            window.selectedFarbeDesignValues.push({
              name: "Farbe",
              value: val.text || val.value,
            });

            const baseImg = new Image();
            baseImg.crossOrigin = "anonymous";
            baseImg.onload = function () {
              currentBaseImage = baseImg;
              redrawCanvas();
            };
            baseImg.src = val.img || `/path/to/shirts/shirt-${(val.value || val.text).toLowerCase()}.png`;
          }

          // Existing functionality for Design
          if (optionName === "Design") {
            window.selectedFarbeDesignValues = window.selectedFarbeDesignValues.filter(
              item => !item.name.includes("Design")
            );

            window.selectedFarbeDesignValues.push({
              name: "Design",
              value: val.text || val.value,
            });

            const designImg = new Image();
            designImg.crossOrigin = "anonymous";
            designImg.onload = function () {
              currentDesignImage = designImg;
              redrawCanvas();
            };
            designImg.src = val.img || `/path/to/designs/design-${(val.value || val.text).toLowerCase()}.png`;
          }
        });

        wrapper.appendChild(valDiv);
      });
    } else {
      wrapper.innerHTML += `<p>No values found for ${optionName}.</p>`;
    }

    return wrapper;
  }


  // Render Farbe
  const farbeElement = renderOptionGroup("Farbe");
  if (farbeElement) farbeContainer.appendChild(farbeElement);


  // Render Design
  const designElement = renderOptionGroup("Design");
  if (designElement) designContainer.appendChild(designElement);

}

let cachedCanvasWidth = null;
let cachedCanvasHeight = null;

renderFarbeOption();

function redrawCanvas() {
  const canvas = document.querySelector(".cl-po--preview-wrapper canvas");

  if (canvas) {
    const resizeObserver = new ResizeObserver(() => {
      // console.log("Canvas resized, redrawing...");
      redrawCanvas();
    });

    resizeObserver.observe(canvas);
  }

  if (!canvas) return;

  canvas.width = canvas.offsetWidth;
  canvas.height = canvas.offsetHeight;

  const ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  if (currentBaseImage) {

    drawImageWithParams(ctx, currentBaseImage, canvas, false); // No refHeight
  }

  if (currentDesignImage) {
    drawImageWithParams(ctx, currentDesignImage, canvas, true); // Use refHeight
  }
}

function drawImageWithParams(ctx, image, canvas, isDesign = false) {
  let drawWidth, drawHeight;

  if (isDesign) {
    const width = window.innerWidth;
    console.log(width)

    if (width <= 480) {
      // 📱 Mobile (phones)
      drawWidth = 180;
      drawHeight = 180;
    } else if (width <= 680) {
      // 📱 Mobile (phones)
      drawWidth = canvas.width * 0.4;
      drawHeight = canvas.height * 0.3;
    } else if (width <= 1100) {
      // 📱📲 Tablet (landscape or portrait)
      drawWidth = canvas.width * 0.46;
      drawHeight = canvas.height * 0.4;
    } else {
      // 🖥️ Desktop
      drawWidth = canvas.width * 0.5;
      drawHeight = canvas.height * 0.5;
    }
  }
  else {
    // Base image scales to fit canvas
    const imgRatio = image.width / image.height;
    const canvasRatio = canvas.width / canvas.height;

    if (imgRatio > canvasRatio) {
      drawWidth = canvas.width;
      drawHeight = canvas.width / imgRatio;
    } else {
      drawHeight = canvas.height;
      drawWidth = canvas.height * imgRatio;
    }
  }


  const xOffset = (canvas.width - drawWidth) / 2;
  const yOffset = (canvas.height - drawHeight) / 2;

  ctx.drawImage(image, xOffset, yOffset, drawWidth, drawHeight);
}

let resizeTimeout = null;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    // console.log("Window resized, debounced redraw...");
    redrawCanvas();
  }, 300);
});



document.addEventListener("DOMContentLoaded", () => {
  const showColorBtn = document.getElementById("show-color-btn");
  const farbeContainer = document.getElementById("farbe-detail-container");

  const showdesignBtn = document.getElementById("show-design-btn");
  const designContainer = document.getElementById("design-detail-container");

  if (showColorBtn && farbeContainer && designContainer) {
    showColorBtn.addEventListener("click", (event) => {
      const bodyDataContainerElement = document.querySelector('#body-data-selection');

      if (bodyDataContainerElement.classList.contains('active')) {
        bodyDataContainerElement.classList.remove('active');
      }
      event.stopPropagation();
      // Toggle color container and hide design container
      const isActive = farbeContainer.classList.toggle("active");
      designContainer.classList.remove("active");
    });
  }

  if (showdesignBtn && designContainer && farbeContainer) {
    showdesignBtn.addEventListener("click", (event) => {
      const bodyDataContainerElement = document.querySelector('#body-data-selection');

      if (bodyDataContainerElement.classList.contains('active')) {
        bodyDataContainerElement.classList.remove('active');
      }
      event.stopPropagation();
      // Toggle design container and hide color container
      const isActive = designContainer.classList.toggle("active");
      farbeContainer.classList.remove("active");
    });
  }

  // Prevent clicks inside either container from closing them
  [farbeContainer, designContainer].forEach(container => {
    if (container) {
      container.addEventListener("click", (event) => {
        event.stopPropagation();
      });
    }
  });

  // Click anywhere else on the document closes both
  document.addEventListener("click", () => {
    if (farbeContainer) farbeContainer.classList.remove("active");
    if (designContainer) designContainer.classList.remove("active");
  });
});



// Toggle messung-wrapper on button click
document.getElementById("show-messung-options-btn").addEventListener("click", () => {
  const messungWrapper = document.getElementById("messung-wrapper");
  messungWrapper.classList.toggle("active");

  if (messungWrapper.classList.contains("active")) {
    renderBodyDataOptions();
  }
});

// Close button inside messung-wrapper
document.getElementById('close-messung').addEventListener('click', function () {
  document.getElementById('messung-wrapper').classList.remove('active');
});
document.addEventListener('click', function (e) {
  if (e.target.closest('#child-back-btn')) {
    document.getElementById('messung-wrapper').classList.remove('active');
  }
});

// Close on outside click
document.addEventListener("click", function (event) {
  const messungWrapper = document.getElementById("messung-wrapper");
  const toggleBtn = document.getElementById("show-messung-options-btn");

  // Ignore clicks on the toggle button or inside the wrapper
  if (
    messungWrapper.classList.contains("active") &&
    !messungWrapper.contains(event.target) &&
    !toggleBtn.contains(event.target)
  ) {
    messungWrapper.classList.remove("active");
  }
});



const renderConditionalFields = (
  conditionalField,
  onConditionFieldObject,
  parentObject,
  conditionalFieldElement = ''
) => {
  conditionalFieldElement.innerHTML = '';

  const conditionalFieldType = conditionalField?.type || '';
  const conditionalFieldValues = conditionalField?.values || [];
  const fieldLabel = conditionalField?.label || conditionalField?.name || 'Zusatzoption';
  const fieldInfo = conditionalField?.params?.info || '';
  const fieldHelp = conditionalField?.params?.help || '';

  // Create label
  const labelEl = document.createElement('label');
  labelEl.textContent = fieldLabel;
  labelEl.classList.add('block', 'mb-1', 'text-sm', 'font-medium', 'text-gray-700');
  conditionalFieldElement.appendChild(labelEl);

  // Info icon if needed
  if (fieldInfo) {
    const infoIcon = document.createElement('span');
    infoIcon.className = 'info-icon';
    infoIcon.title = fieldInfo;
    infoIcon.textContent = ' i';
    labelEl.appendChild(infoIcon);
  }

  if (conditionalFieldType === "select") {
    const selectWrapper = document.createElement('div');
    selectWrapper.classList.add('mb-4');

    const selectEl = document.createElement('select');
    selectEl.classList.add(
      'w-full',
      'border',
      'border-gray-300',
      'rounded',
      'p-2',
      'text-sm',
      'focus:outline-none',
      'focus:ring-2',
      'focus:ring-blue-500'
    );

    // Get saved value from selection state
    const savedValue = window.selectedZusatzlicheOptionenValues?.find(
      item => item.name === (conditionalField.name || conditionalField.label)
    )?.value;

    // Add a placeholder
    const placeholderOption = document.createElement('option');
    placeholderOption.disabled = true;
    placeholderOption.selected = !savedValue; // select if no saved value
    placeholderOption.textContent = '';
    selectEl.appendChild(placeholderOption);

    // Add options
    conditionalFieldValues.forEach(val => {
      const option = document.createElement('option');
      const optionValue = val?.value || val?.text || val?.label;
      const optionText = val?.text || val?.value || val?.label;

      option.value = optionValue;
      option.textContent = optionText;

      // Restore saved selection
      if (savedValue && (savedValue === optionText || savedValue === optionValue)) {
        option.selected = true;
      }

      selectEl.appendChild(option);
    });

    // Store selected value on change
    selectEl.addEventListener("change", () => {
      const selectedValue = selectEl.value;
      const selectedText = selectEl.options[selectEl.selectedIndex].text;
      const name = conditionalField.name || conditionalField.label;

      window.selectedZusatzlicheOptionenValues = window.selectedZusatzlicheOptionenValues || [];
      window.selectedZusatzlicheOptionenValues = window.selectedZusatzlicheOptionenValues.filter(
        item => item.name !== name
      );
      window.selectedZusatzlicheOptionenValues.push({ name, value: selectedText });

      console.log("Updated selected options:", window.selectedZusatzlicheOptionenValues);
    });

    selectWrapper.appendChild(selectEl);
    conditionalFieldElement.appendChild(selectWrapper);
  }

  // Help text if any
  if (fieldHelp) {
    const helpEl = document.createElement('p');
    helpEl.textContent = fieldHelp;
    helpEl.classList.add('mt-1', 'text-xs', 'text-gray-500');
    conditionalFieldElement.appendChild(helpEl);
  }
};




// Global object to store user selections
window.selectedProductOptions = {};
// 👇 Declare only once outside any loop or re-used function
window.selectedZusatzlicheOptionenValues = window.selectedZusatzlicheOptionenValues || [];
window.selectedWeitereOptionenPassformValues = window.selectedWeitereOptionenPassformValues || [];
window.lastUserSelectedOption = null;

function renderProductLevels() {
  const container = document.getElementById("product-list-item");
  const detailContainer = document.getElementById("product-detail-container");
  const configs = window?.Cloudlift?.options?.App?.config?.configs;

  if (!container || !detailContainer || !Array.isArray(configs)) {
    return setTimeout(renderProductLevels, 300);
  }

  const baseProductPrice = (() => {
    const raw = document.querySelector(".product-price")?.dataset.rawPrice;
    return raw ? Number(parseFloat(raw).toFixed(2)) : 0;
  })();

  let selectedAddOnPrices = [];

  function updateTotalPrice() {
    const total = baseProductPrice + selectedAddOnPrices.reduce((sum, p) => sum + p.price, 0);
    const priceEl = document.querySelector(".product-price");

    if (priceEl) {
      const currency = Shopify.currency?.active || Shopify.currency?.currentCurrency || 'EUR';

      // Format number with dynamic currency symbol
      let formatted = new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(total);

      // Replace ₹ with Rs. for INR
      if (currency === "INR") {
        formatted = formatted.replace(/₹/, "Rs. ");
      }

      // Update displayed price
      priceEl.textContent = formatted;

      // Handle hidden input for Shopify's logic
      const totalPrice = selectedAddOnPrices.reduce((sum, p) => sum + p.price, 0);
      const priceInput = document.querySelector('#cl_options_price');
      if (priceInput) {
        const priceInCents = Math.round(totalPrice * 100);
        priceInput.value = priceInCents.toString();
      }
    }
  }


  updateTotalPrice();

  const sectionElement = document.querySelector('.template-product-new-product');
  const currentProductId = sectionElement?.dataset.productId;

  const matchingConfigs = configs.filter(cfg => {
    const targetMode = cfg?.targetMode;
    if (targetMode === 1) {
      const conditionProducts = cfg?.conditions?.[0]?.products;
      const ids = Array.isArray(conditionProducts) ? conditionProducts.map(p => p.id) : [];
      return ids.includes(currentProductId);
    } else {
      const liveId = cfg?.product?.id || cfg?.targeting?.product?.id;
      return currentProductId == liveId;
    }
  });

  if (matchingConfigs.length === 0) return;

  const allItems = matchingConfigs.flatMap(cfg => cfg.options || []);
  container.innerHTML = "";
  detailContainer.innerHTML = "";

  const altField = allItems.find(
    item => item.name === "Alternative Produktmöglichkeiten" || item.label === "Alternative Produktmöglichkeiten"
  );

  if (!altField || !Array.isArray(altField.values)) return;
  const altFieldName = altField.name || "Alternative Produktmöglichkeiten";

  altField.values.forEach(val => {
    if (val.visible === false) return;
    const valLabel = val.text || val.label || val.value || "Unbenannt";

    const groupWrapper = document.createElement("div");
    groupWrapper.className = "product-level";

    const valEl = document.createElement("div");
    valEl.className = "product-level-box";
    valEl.innerHTML = `<div class="product-level-box-title">${valLabel}</div>`;
    groupWrapper.appendChild(valEl);

    // Render the group title above the selected item on the cart page
    const cartProductList = document.querySelector(".cart-product-list");
    if (cartProductList) {
      const groupTitleEl = document.createElement("div");
      groupTitleEl.className = "cart-group-title";
      groupTitleEl.textContent = valLabel; // Display the main group title
      cartProductList.prepend(groupTitleEl); // Adds the group title above the selected item
    }

    const conditionalGroups = allItems.filter(
      group =>
        Array.isArray(group.conditions) &&
        group.conditions.every(cond => {
          if (cond.field === altFieldName && cond.value === val.value) return true;
          if (cond.field === 'variant') {
            const currentVariant = Shopify?.product?.variantId || sectionElement?.dataset?.variantId;
            return cond.variants?.includes?.(currentVariant);
          }
          return false;
        })
    );

    if (conditionalGroups.length) {
      const conditionContainer = document.createElement("div");
      conditionContainer.className = "sub-option-list";
      const withCondition = [];

      const selectedZusatzlicheOptionenValues = [];
      const selectedWeitereOptionenPassformValues = [];



      conditionalGroups.forEach(group => {
        if (!Array.isArray(group.options)) return;

        group.options.forEach(opt => {
          const alreadySelected = window.selectedProductOptions?.[opt.name];
          if (!alreadySelected && Array.isArray(opt.values)) {
            const currentGroup = valLabel?.trim() || group.label?.trim() || '';

            // Filter by group type - only process if the group is relevant
            const relevantGroups = ["ZUSÄTZLICHE PRODUKTOPTIONEN", "WEITERE OPTIONEN PASSFORM"];
            if (relevantGroups.includes(currentGroup)) {
              const defaultVal =
                opt.values.find(
                  (v) =>
                    v.visible !== false &&
                    (v.isDefault || v.default || opt.value === v.value || opt.default === v.value)
                ) || opt.values.find((v) => v.visible !== false);

              if (defaultVal) {
                const defaultValue = defaultVal.value;
                const defaultPrice = parseFloat(defaultVal.price || "0");

                window.selectedProductOptions[opt.name] = defaultValue;
                selectedAddOnPrices = selectedAddOnPrices.filter((p) => p.group !== opt.name);
                selectedAddOnPrices.push({ group: opt.name, price: defaultPrice });

                if (opt.type === 'img-swatch' && opt.name !== "Taschengröße" && opt.name !== "Taschenform")
                  if (currentGroup === "ZUSÄTZLICHE PRODUKTOPTIONEN") {
                    window.selectedZusatzlicheOptionenValues.push({ name: opt.name, value: defaultValue });
                    window.lastUpdatedProductOptionsGroup = "ZUSÄTZLICHE";

                  } else if (currentGroup === "WEITERE OPTIONEN PASSFORM") {
                    window.selectedWeitereOptionenPassformValues.push({ name: opt.name, value: defaultValue });
                    window.lastUpdatedProductOptionsGroup = "WEITERE";
                  }
                // console.log(`Assigned default for [${opt.name}] in group [${currentGroup}]`);
              } else if (currentGroup === "WEITERE OPTIONEN PASSFORM") {
                console.log(`No options for WEITERE OPTIONEN PASSFORM`);
              }

            }
            // console.log("ZUSÄTZLICHE PRODUKTOPTIONEN VALUES:", window.selectedZusatzlicheOptionenValues);
            // console.log("WEITERE OPTIONEN PASSFORM VALUES:", window.selectedWeitereOptionenPassformValues);
          }


          if (opt.conditions.length > 0) {
            withCondition.push(opt);
            return;
          }

          const optLabel = opt.label || opt.name || "Unnamed Option";
          let optImage = "https://via.placeholder.com/60";
          if (Array.isArray(opt.values)) {
            const valWithImg = opt.values.find(v => v.visible !== false && v.img);
            if (valWithImg) optImage = valWithImg.img;
          }

          const selectedVal = window.selectedProductOptions?.[optLabel];
          const summaryHtml = selectedVal ? `<div class="selected-summary">${selectedVal}</div>` : "";

          const optEl = document.createElement("div");
          optEl.className = "sub-option-box";
          optEl.innerHTML = `
          <div class="sub-option-box-img"><img src="${optImage}" /></div>
          <div class="sub-option-box-title">${optLabel}</div>
        `;

          optEl.addEventListener("click", () => {

            const bodyDataContainerElement = document.querySelector('#body-data-selection');

            if (bodyDataContainerElement.classList.contains('active')) {
              bodyDataContainerElement.classList.remove('active');
            }

            const allOptions = conditionContainer.querySelectorAll(".sub-option-box");
            allOptions.forEach(o => o.classList.remove("selected"));
            optEl.classList.add("selected");
            const parentLabel = groupWrapper.querySelector(".product-level-box-title").textContent;

            // Save it in selectedProductOptions for cart display
            window.selectedProductOptions[altFieldName] = parentLabel;
            const isActive = detailContainer.classList.contains("active");
            const isSame = detailContainer.getAttribute("data-current") === opt.name;
            window.lastUpdatedProductOptionsGroup = opt.name;
            console.log("current value:", window.lastUpdatedProductOptionsGroup);

            if (isActive && isSame) {
              detailContainer.innerHTML = "";
              detailContainer.classList.remove("active");
              detailContainer.removeAttribute("data-current");
              return;
            }
            detailContainer.innerHTML = `
            <div class="detail-header custom-popup-header">
              <h2 class="detail-title">${optLabel}</h2>
              <span class="detail-close close-button">Erledigt</span>
            </div>
            <div class="custom-popup-body">
              <div class="selected-value-display"></div>
              <div class="level-2-values"></div>
            </div>
          `;

            detailContainer.classList.add("active");
            detailContainer.setAttribute("data-current", opt.name);

            detailContainer.querySelector(".detail-close").addEventListener("click", () => {
              detailContainer.innerHTML = "";
              detailContainer.classList.remove("active");
              detailContainer.removeAttribute("data-current");
            });

            const valuesWrapper = detailContainer.querySelector(".level-2-values");

            if (Array.isArray(opt.values)) {
              // Default selection of options
              // const currentVal = window.selectedProductOptions[opt.name];
              // if (!currentVal) {
              //   const defaultVal = opt.values.find(v => v.visible !== false && (v.isDefault || v.default || opt.value === v.value || opt.default === v.value)) || opt.values.find(v => v.visible !== false);
              //   if (defaultVal) {
              //     const defaultValue = defaultVal.value;
              //     const defaultPrice = parseFloat(defaultVal.price || "0");
              //     window.selectedProductOptions[opt.name] = defaultValue;
              //     selectedAddOnPrices = selectedAddOnPrices.filter(p => p.group !== opt.name);
              //     selectedAddOnPrices.push({ group: opt.name, price: defaultPrice });
              //   }
              // }

              opt.values
                .filter(val => val.visible !== false)
                .forEach(val => {

                  const valLabel = val.text || val.label || val.value || "Value";
                  const valImage = val.img || "https://via.placeholder.com/60";
                  const valPrice = parseFloat(val.price || "0");

                  const valEl = document.createElement("div");
                  valEl.className = "sub-product-box";
                  valEl.innerHTML = `
                  <div class="sub-product-box-img"><img src="${valImage}" /></div>
                  <div class="sub-product-box-title">${valLabel} ${valPrice ? `(+${formatCurrency(valPrice)})` : ""}</div>
                `;

                  const isSelected = window.selectedProductOptions?.[opt.name] === val.value;
                  if (isSelected) {
                    valEl.classList.add("selected");
                    const selectedDisplay = detailContainer.querySelector(".selected-value-display");
                    if (selectedDisplay) {
                      selectedDisplay.textContent = `${valLabel} ${valPrice ? `(+${formatCurrency(valPrice)})` : ""}`;
                    }

                    selectedAddOnPrices = selectedAddOnPrices.filter(p => p.group !== opt.name);
                    selectedAddOnPrices.push({ group: opt.name, price: valPrice });
                    updateTotalPrice();

                    if (val.value && withCondition.length > 0) {
                      const match = withCondition.find(obj =>
                        obj.conditions?.some(
                          cond =>
                            cond.value === val.value &&
                            cond.field === (opt.name || opt.label)
                        )
                      );

                      if (match) {
                        const existing = detailContainer.querySelector(".level-2-values-condition");
                        if (existing) existing.remove();

                        const level_2_conditional_div = document.createElement('div');
                        level_2_conditional_div.className = "level-2-values-condition";
                        valuesWrapper.parentNode.insertBefore(level_2_conditional_div, valuesWrapper.nextSibling);
                        renderConditionalFields(match, val, opt, level_2_conditional_div, window.selectedProductOptions);
                      }
                    }
                  }

                  valEl.addEventListener("click", () => {
                    const allBoxes = valuesWrapper.querySelectorAll(".sub-product-box");
                    allBoxes.forEach(box => box.classList.remove("selected"));
                    valEl.classList.add("selected");

                    const selectedDisplay = detailContainer.querySelector(".selected-value-display");
                    if (selectedDisplay) selectedDisplay.textContent = `${valLabel} ${valPrice ? `(+${formatCurrency(valPrice)})` : ""}`;

                    const groupKey = detailContainer.getAttribute("data-current");
                    window.selectedProductOptions[groupKey] = val.value;

                    function updateSelectedOptionValue(array, name, value, price) {
                      const existingIndex = array.findIndex(item => item.name === name || item.label === name);
                      if (existingIndex !== -1) {
                        array[existingIndex].value = value;
                        array[existingIndex].price = price; // update price too
                        console.log(`Updated value and price in array for "${name}":`, array);
                      } else {
                        console.log(`"${name}" not found in array, no update done.`);
                      }
                    }


                    const userValue = val.value;
                    const valueToUse = userValue || defaultValue;
                    const valuePrice = val.price;
                    console.log("Current value selected by user:", userValue);

                    updateSelectedOptionValue(window.selectedZusatzlicheOptionenValues, opt.name, valueToUse, valuePrice);
                    updateSelectedOptionValue(window.selectedWeitereOptionenPassformValues, opt.name, valueToUse, valuePrice);



                    selectedAddOnPrices = selectedAddOnPrices.filter(p => p.group !== groupKey);
                    selectedAddOnPrices.push({ group: groupKey, price: valPrice });
                    updateTotalPrice();

                    const getConditionalValue = val.value;
                    const existingConditionalDiv = detailContainer.querySelector(".level-2-values-condition");
                    if (existingConditionalDiv) existingConditionalDiv.remove();

                    if (getConditionalValue && withCondition.length > 0) {
                      if (opt.name === 'Tasche-g' || opt.label === 'Tasche-g') {
                        ['Taschenform', 'Taschengröße'].forEach(name => {
                          const toRemove = detailContainer.querySelector(`.sub-option-list[data-field="${name}"]`);
                          if (toRemove) toRemove.remove();
                          delete window.selectedProductOptions[name];
                          selectedAddOnPrices = selectedAddOnPrices.filter(p => p.group !== name);
                        });

                        if (getConditionalValue !== 'keine Tasche') {
                          const taschenFields = ['Taschenform', 'Taschengröße'];


                          taschenFields.forEach(fieldName => {
                            const matchField = withCondition.find(obj =>
                              obj.name === fieldName || obj.label === fieldName
                            );

                            if (matchField && Array.isArray(matchField.values)) {
                              const section = document.createElement("div");
                              section.className = "sub-option-list level-2-values-condition";
                              section.setAttribute("data-field", fieldName);


                              const labelEl = document.createElement("div");
                              labelEl.className = "sub-option-title";
                              labelEl.textContent = matchField.label || matchField.name;
                              section.appendChild(labelEl);


                              // Get default value (prioritize explicit default)
                              const defaultVal =
                                matchField.values.find(v => v.visible !== false && (v.default || v.isDefault)) ||
                                matchField.values.find(v => v.visible !== false);

                              matchField.values
                                .filter(v => v.visible !== false)
                                .forEach(val => {
                                  const valLabel = val.text || val.label || val.value;
                                  const valImage = val.img || "https://via.placeholder.com/60";
                                  const valPrice = parseFloat(val.price || "0");

                                  const valEl = document.createElement("div");
                                  valEl.className = "sub-product-box";
                                  valEl.innerHTML = `<div class="sub-product-box-img"><img src="${valImage}" /></div><div class="sub-product-box-title">${valLabel} ${valPrice ? `(+${formatCurrency(valPrice)})` : ""}</div>`;


                                  // ✅ Persist selected state from stored values (even after box reopens)
                                  const selectedStored = window.selectedZusatzlicheOptionenValues?.find(item => item.name === fieldName);
                                  const isSelected = selectedStored?.value === val.value || (!selectedStored && defaultVal?.value === val.value);

                                  if (isSelected) {
                                    valEl.classList.add("selected");
                                  }


                                  valEl.addEventListener("click", () => {
                                    const allBoxes = section.querySelectorAll(".sub-product-box");
                                    allBoxes.forEach(box => box.classList.remove("selected"));
                                    valEl.classList.add("selected");

                                    window.selectedProductOptions[fieldName] = val.value;
                                    window.selectedZusatzlicheOptionenValues = window.selectedZusatzlicheOptionenValues || [];
                                    window.selectedZusatzlicheOptionenValues = window.selectedZusatzlicheOptionenValues.filter(item => item.name !== fieldName);
                                    window.selectedZusatzlicheOptionenValues.push({ name: fieldName, value: val.value });

                                    console.log("Child options:", window.selectedZusatzlicheOptionenValues);

                                    if (fieldName === 'Taschengröße' && val.value === 'individuell') {
                                      const subFields = ['Taschenhöhe', 'Taschenbreite'];
                                      subFields.forEach(subName => {
                                        const alreadyExists = detailContainer.querySelector(`.sub-option-list[data-field="${subName}"]`);
                                        if (alreadyExists) return;

                                        const matchSub = withCondition.find(obj =>
                                          obj.name === subName || obj.label === subName
                                        );

                                        if (matchSub) {
                                          const selectWrapper = document.createElement('div');
                                          selectWrapper.className = "sub-option-list level-3-values-select";
                                          selectWrapper.setAttribute("data-field", subName);

                                          renderConditionalFields(matchSub, val, matchField, selectWrapper, window.selectedProductOptions);
                                          section.appendChild(selectWrapper);
                                        }
                                      });
                                    } else if (fieldName === 'Taschengröße') {
                                      // Hide/remove Taschenhöhe and Taschenbreite if not 'individuell'
                                      const subFieldsToRemove = ['Taschenhöhe', 'Taschenbreite'];
                                      subFieldsToRemove.forEach(subName => {
                                        const subEl = section.querySelector(`.sub-option-list[data-field="${subName}"]`);
                                        if (subEl) {
                                          subEl.remove();
                                        }
                                      });
                                    }
                                  });


                                  section.appendChild(valEl);
                                });


                              // ✅ Append to DOM
                              valuesWrapper.parentNode.insertBefore(section, valuesWrapper.nextSibling);


                              // ✅ Store default only if not already stored
                              if (defaultVal && !window.selectedZusatzlicheOptionenValues?.some(item => item.name === fieldName)) {
                                window.selectedZusatzlicheOptionenValues = window.selectedZusatzlicheOptionenValues || [];
                                window.selectedZusatzlicheOptionenValues.push({
                                  name: fieldName,
                                  value: defaultVal.value
                                });
                                console.log(`Default stored for ${fieldName}:`, defaultVal.value);
                              }
                            }
                          });
                        }



                        updateTotalPrice();
                      }

                      const match = withCondition.find(obj =>
                        obj.conditions?.some(
                          cond =>
                            cond.value === getConditionalValue &&
                            cond.field === (opt.name || opt.label)
                        )
                      );

                      if (match) {
                        const level_2_conditional_div = document.createElement('div');
                        level_2_conditional_div.className = "level-2-values-condition";
                        valuesWrapper.parentNode.insertBefore(level_2_conditional_div, valuesWrapper.nextSibling);
                        renderConditionalFields(match, val, opt, level_2_conditional_div, window.selectedProductOptions);
                      }
                    }
                  });

                  const currentValue = window.selectedProductOptions['Tasche-g'];
                  // console.log("Current value for Taschengröße:", currentValue);

                  if (currentValue !== 'keine Tasche') {
                    const getConditionalValue = val.value;
                    const existingConditionalDiv = detailContainer.querySelector(".level-2-values-condition");
                    if (existingConditionalDiv) existingConditionalDiv.remove();

                    if (getConditionalValue && withCondition.length > 0) {
                      if (opt.name === 'Tasche-g' || opt.label === 'Tasche-g') {
                        ['Taschenform', 'Taschengröße'].forEach(name => {
                          const toRemove = detailContainer.querySelector(`.sub-option-list[data-field="${name}"]`);
                          if (toRemove) toRemove.remove();
                          delete window.selectedProductOptions[name];
                          selectedAddOnPrices = selectedAddOnPrices.filter(p => p.group !== name);
                        });

                        if (getConditionalValue !== 'keine Tasche') {
                          const taschenFields = ['Taschenform', 'Taschengröße'];


                          taschenFields.forEach(fieldName => {
                            const matchField = withCondition.find(obj =>
                              obj.name === fieldName || obj.label === fieldName
                            );

                            if (matchField && Array.isArray(matchField.values)) {
                              const section = document.createElement("div");
                              section.className = "sub-option-list level-2-values-condition";
                              section.setAttribute("data-field", fieldName);


                              const labelEl = document.createElement("div");
                              labelEl.className = "sub-option-title";
                              labelEl.textContent = matchField.label || matchField.name;
                              section.appendChild(labelEl);


                              // Get default value (prioritize explicit default)
                              const defaultVal =
                                matchField.values.find(v => v.visible !== false && (v.default || v.isDefault)) ||
                                matchField.values.find(v => v.visible !== false);


                              matchField.values
                                .filter(v => v.visible !== false)
                                .forEach(val => {
                                  const valLabel = val.text || val.label || val.value;
                                  const valImage = val.img || "https://via.placeholder.com/60";
                                  const valPrice = parseFloat(val.price || "0");

                                  const valEl = document.createElement("div");
                                  valEl.className = "sub-product-box";
                                  valEl.innerHTML = `<div class="sub-product-box-img"><img src="${valImage}" /></div><div class="sub-product-box-title">${valLabel} ${valPrice ? `(+${formatCurrency(valPrice)})` : ""}</div>`;

                                  // ✅ Persist selected state from stored values
                                  const isSelected = window.selectedProductOptions?.[fieldName] === val.value;
                                  if (isSelected) {
                                    valEl.classList.add("selected");
                                  }

                                  valEl.addEventListener("click", () => {

                                    // ✅ Persist to global selection tracker
                                    window.selectedProductOptions[fieldName] = val.value;
                                    console.log(`Selected option updated: ${fieldName} = ${val.value}`);

                                    window.selectedZusatzlicheOptionenValues = window.selectedZusatzlicheOptionenValues || [];
                                    window.selectedZusatzlicheOptionenValues = window.selectedZusatzlicheOptionenValues.filter(
                                      item => item.name !== fieldName
                                    );
                                    window.selectedZusatzlicheOptionenValues.push({ name: fieldName, value: val.value });

                                    console.log("Child options:", window.selectedZusatzlicheOptionenValues);

                                    if (fieldName === 'Taschengröße' && val.value === 'individuell') {
                                      const subFields = ['Taschenhöhe', 'Taschenbreite'];
                                      subFields.forEach(subName => {
                                        const alreadyExists = detailContainer.querySelector(`.sub-option-list[data-field="${subName}"]`);
                                        if (alreadyExists) return;

                                        const matchSub = withCondition.find(obj =>
                                          obj.name === subName || obj.label === subName
                                        );

                                        if (matchSub) {
                                          const selectWrapper = document.createElement('div');
                                          selectWrapper.className = "sub-option-list level-3-values-select";
                                          selectWrapper.setAttribute("data-field", subName);

                                          renderConditionalFields(matchSub, val, matchField, selectWrapper, window.selectedProductOptions);
                                          section.appendChild(selectWrapper);
                                        }
                                      });
                                    } else if (fieldName === 'Taschengröße') {
                                      // Hide/remove Taschenhöhe and Taschenbreite if not 'individuell'
                                      const subFieldsToRemove = ['Taschenhöhe', 'Taschenbreite'];
                                      subFieldsToRemove.forEach(subName => {
                                        const subEl = section.querySelector(`.sub-option-list[data-field="${subName}"]`);
                                        if (subEl) {
                                          subEl.remove();
                                        }
                                      });
                                    }

                                    selectedAddOnPrices = selectedAddOnPrices.filter(p => p.group !== fieldName);
                                    selectedAddOnPrices.push({ group: fieldName, price: valPrice });
                                    updateTotalPrice();
                                  });

                                  section.appendChild(valEl);
                                });


                              // ✅ Append to DOM
                              valuesWrapper.parentNode.insertBefore(section, valuesWrapper.nextSibling);


                              // ✅ Store default only if not already stored
                              if (defaultVal && !window.selectedZusatzlicheOptionenValues?.some(item => item.name === fieldName)) {
                                window.selectedZusatzlicheOptionenValues = window.selectedZusatzlicheOptionenValues || [];
                                window.selectedZusatzlicheOptionenValues.push({
                                  name: fieldName,
                                  value: defaultVal.value
                                });
                                console.log(`Default stored for ${fieldName}:`, defaultVal.value);
                              }
                            }
                          });
                        }



                        updateTotalPrice();
                      }

                      const match = withCondition.find(obj =>
                        obj.conditions?.some(
                          cond =>
                            cond.value === getConditionalValue &&
                            cond.field === (opt.name || opt.label)
                        )
                      );

                      if (match) {
                        const level_2_conditional_div = document.createElement('div');
                        level_2_conditional_div.className = "level-2-values-condition";
                        valuesWrapper.parentNode.insertBefore(level_2_conditional_div, valuesWrapper.nextSibling);
                        renderConditionalFields(match, val, opt, level_2_conditional_div, window.selectedProductOptions);
                      }
                    }
                  }
                  valuesWrapper.appendChild(valEl);
                });
            }
          });

          conditionContainer.appendChild(optEl);
        });

      });

      groupWrapper.appendChild(conditionContainer);
    }

    container.appendChild(groupWrapper);
  });

  document.addEventListener("click", function (event) {
    const isClickInside = detailContainer.contains(event.target);
    const isOptionBox = event.target.closest(".sub-option-box");
    if (!isClickInside && !isOptionBox && detailContainer.classList.contains("active")) {
      detailContainer.innerHTML = "";
      detailContainer.classList.remove("active");
      detailContainer.removeAttribute("data-current");
    }
  });
}



function formatCurrency(value) {
  const currency = window.Shopify?.currency?.active || "EUR";
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: currency
  }).format(value);
}



document.addEventListener("DOMContentLoaded", () => {
  setTimeout(renderProductLevels, 300);
});

document.addEventListener(
  'click',
  function (event) {
    const selector = '.shopify-payment-button, [data-shopify="payment-button"]';
    if (event.target && event.target.closest(selector)) {
      // alert('Shopify accelerated/dynamic payment button clicked!');
      // Run your custom function
      addFormProperties(event);
    }
  },
  true // capture phase
);

function addFormProperties(e) {
  const form = document.querySelector('form[action="/cart/add"]');
  if (!form) return;

  let finalOptions = [];
  let groupLabel = "";

  const hasBody = Array.isArray(window.selectedBodyDataArray) && window.selectedBodyDataArray.length > 0;
  const hasWeitereOptionenPassform = window.selectedWeitereOptionenPassformValues.some(option =>
    option.name === window.lastUpdatedProductOptionsGroup
    || option.label === window.lastUpdatedProductOptionsGroup
    || option.value === window.lastUpdatedProductOptionsGroup
  );

  const hasZusatzlicheOptionen = window.selectedZusatzlicheOptionenValues.some(option =>
    option.name === window.lastUpdatedProductOptionsGroup
    || option.label === window.lastUpdatedProductOptionsGroup
    || option.value === window.lastUpdatedProductOptionsGroup
  );

  const hasFarbeDesign = Array.isArray(window.selectedFarbeDesignValues) &&
    window.selectedFarbeDesignValues.length > 0;

  // Merge logic ignoring order of selection (just check if both arrays have data)
  if (hasBody && hasWeitereOptionenPassform) {
    finalOptions = [...window.selectedWeitereOptionenPassformValues, ...window.selectedBodyDataArray];
    groupLabel = "Alternative Produktmöglichkeiten: WEITERE OPTIONEN PASSFORM";
  } else if (hasBody && hasZusatzlicheOptionen) {
    finalOptions = [...window.selectedZusatzlicheOptionenValues, ...window.selectedBodyDataArray];
    groupLabel = "Alternative Produktmöglichkeiten: ZUSÄTZLICHE PRODUKTOPTIONEN";
  } else if (hasWeitereOptionenPassform) {
    finalOptions = window.selectedWeitereOptionenPassformValues;
    groupLabel = "Alternative Produktmöglichkeiten: WEITERE OPTIONEN PASSFORM";
  } else if (hasZusatzlicheOptionen) {
    finalOptions = window.selectedZusatzlicheOptionenValues;
    groupLabel = "Alternative Produktmöglichkeiten: ZUSÄTZLICHE PRODUKTOPTIONEN";
  } else if (hasBody) {
    finalOptions = window.selectedBodyDataArray;
    // groupLabel = "Alternative Produktmöglichkeiten: Body";
  }

  // NEW: Add Farbe/Design options (these will appear as separate properties)
  if (hasFarbeDesign) {
    finalOptions = [...finalOptions, ...window.selectedFarbeDesignValues];
  }
  
  // 🔄 Remove any previously injected hidden fields
  form.querySelectorAll('.custom-prop').forEach(el => el.remove());

  // 🔒 Add hidden inputs for selected options
  finalOptions.forEach(({ name, value, price }) => {
    const trimmedName = name.trim();

    // Get current currency settings from Shopify
    const currencyCode = Shopify.currency?.active || Shopify.currency?.currentCurrency || 'EUR';

    let valueWithPrice = value;

    if (typeof price !== "undefined" && !isNaN(price)) {
      let formattedPrice = new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currencyCode,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(price);

      // Only override for INR
      if (currencyCode === "INR") {
        // Replace ₹ (with optional space) with Rs. and a space
        formattedPrice = formattedPrice.replace(/₹\s?/, "Rs. ");
      }

      valueWithPrice = `${value} | ${formattedPrice}`;
    }


    const input = document.createElement("input");
    input.type = "hidden";
    input.name = `properties[${trimmedName}]`;
    input.value = valueWithPrice;
    input.classList.add("custom-prop");
    form.appendChild(input);
  });

  // 🏷️ Add group label input at the top of the form
  if (groupLabel) {
    const labelParts = groupLabel.split(":");
    const namePart = labelParts[0]?.trim() || "Alternative Produktmöglichkeiten";
    const valuePart = labelParts[1]?.trim() || "";

    const groupInput = document.createElement("input");
    groupInput.name = `properties[${namePart}]`; // This becomes the key
    groupInput.type = "hidden";
    groupInput.value = valuePart; // This becomes the value
    groupInput.classList.add("custom-prop");

    // Insert it at the top of the form before other custom props
    const firstCustomProp = form.querySelector('.custom-prop');
    if (firstCustomProp) {
      form.insertBefore(groupInput, firstCustomProp);
    } else {
      form.appendChild(groupInput);
    }
  }

  // Optional: Include calculated prices
  const clOptionsPrice = document.querySelector('#cl_options_price')?.value;
  const clOptionsBasePrice = document.querySelector('#cl_options_base_price')?.value;

  if (clOptionsPrice) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "properties[_cl_options_price]";
    input.value = clOptionsPrice;
    input.classList.add("custom-prop");
    form.appendChild(input);
  }

  if (clOptionsBasePrice) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "properties[_cl_options_base_price]";
    input.value = clOptionsBasePrice;
    input.classList.add("custom-prop");
    form.appendChild(input);
  }

  console.log("✅ Added custom line item properties:", finalOptions);
}




document.querySelector('form[action="/cart/add"]').addEventListener("submit", function (e) {

  addFormProperties(e);
});



function updateCart() {
  fetch(window.Shopify.routes.root + '/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Optionally update cart count or show success message
      // window.location.href = '/cart'; // Navigate to the cart page
    })
    .catch(error => {
      console.error("Error updating the cart:", error);
    });
}

document.getElementById('show-options-btn').addEventListener('click', function (event) {
  document.querySelector('.custom-popup').classList.toggle('active');
  const width = window.innerWidth;
  if (width >= 768 && width <= 1024) {
    event.stopPropagation(); // prevent outside click from immediately closing
  }
});

document.addEventListener('click', function (event) {
  const popup = document.querySelector('.custom-popup');
  if (!popup) return;

  const width = window.innerWidth;
  if (width >= 768 && width <= 1024) {
    if (popup.classList.contains('active')) {
      const isInsidePopup = popup.contains(event.target);
      const isInsideMessungWrapperActive = event.target.closest('.messung-wrapper.active') !== null;

      if (!isInsidePopup && !isInsideMessungWrapperActive) {
        popup.classList.remove('active');
      }
    }
  }
});


document.getElementById('body-data-container').addEventListener('click', function () {
  document.querySelector('.custom-popup').classList.remove('active');
});

document.getElementById('close-messung').addEventListener('click', function () {
  document.getElementById('body-data-container').click();
});


document.addEventListener("DOMContentLoaded", function () {
  const secondInnerBody = document.querySelector(".child-items.second-inner-body");
  const labels = secondInnerBody.querySelectorAll(".gender-radio-label");

  // Add click events to each label
  labels.forEach(label => {
    label.addEventListener("click", function () {
      labels.forEach(l => l.classList.remove("active"));
      this.classList.add("active");

      const input = this.querySelector('input[type="radio"]');
      if (input) {
        input.checked = true;
      }
    });
  });

  // Observe changes to the 'class' attribute of secondInnerBody
  if (secondInnerBody) {
    const observer = new MutationObserver(function (mutationsList) {
      for (let mutation of mutationsList) {
        if (mutation.attributeName === "class") {
          const hasActive = secondInnerBody.classList.contains("active");

          if (!hasActive) {
            // If not active, reset all and select the first label
            labels.forEach(l => {
              l.classList.remove("active");
              const input = l.querySelector('input[type="radio"]');
              if (input) input.checked = false;
            });

            const firstLabel = labels[0];
            firstLabel.classList.add("active");
            const firstInput = firstLabel.querySelector('input[type="radio"]');
            if (firstInput) firstInput.checked = true;

            console.log("Reset to first gender option due to second-inner-body becoming inactive.");
          }
        }
      }
    });

    observer.observe(secondInnerBody, { attributes: true });
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const autoScanBtn = document.getElementById("mk-auto-scan-container");
  const secondInnerBody = document.querySelector(".child-items.second-inner-body");
  const innerPopupBody = document.querySelector(".inner-popup-body");
  const backTitle = document.querySelector(".child-item-title.back-title .back-btn");

  const secondStepContainer = document.querySelector(".second-step-container");
  const mkLoader = document.getElementById("mk-loader");
  const mkQrContainer = document.getElementById("mk-qrcode-img-container");

  // Show second screen, hide inner popup
  if (autoScanBtn && secondInnerBody && innerPopupBody) {
    autoScanBtn.addEventListener("click", function () {
      secondInnerBody.classList.add("active");
      innerPopupBody.style.display = "none";

      // If second-step-container is block, also show loader & QR code
      if (secondStepContainer && getComputedStyle(secondStepContainer).display === "block") {
        if (mkLoader) mkLoader.style.display = "block";
        if (mkQrContainer) mkQrContainer.style.display = "block";
      }
    });
  }

  // Back to first screen
  if (backTitle && secondInnerBody && innerPopupBody) {
    backTitle.addEventListener("click", function () {
      secondInnerBody.classList.remove("active");
      innerPopupBody.style.display = "block";

      // Hide loader & QR code again
      if (mkLoader) mkLoader.style.display = "none";
      if (mkQrContainer) mkQrContainer.style.display = "none";
    });
  }
});




const replaceText = () => {
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  let node;
  while ((node = walker.nextNode())) {
    if (node.nodeValue.includes("Completed")) {
      node.nodeValue = node.nodeValue.replace(/\bCompleted\b/g, "Done");
    }
  }
};

window.addEventListener("load", () => setTimeout(replaceText, 2000));

new MutationObserver(replaceText).observe(document.body, {
  childList: true,
  subtree: true,
});